class Header {
    constructor() {
        this.header = document.querySelector('.header');
        this.elements = {
            el: this.header,
            menuDrawer: this.header.querySelector('.header__menu-drawer__container'),
            closeMenu: this.header.querySelector('.header__menu__close-icon'),
            openMenu: this.header.querySelector('.header__menu__open-icon'),
            border: this.header.querySelectorAll('.menu-drawer-border'),
            logo: this.header.querySelector('.header__menu-brand-logo'),
            menuItems: this.header.querySelectorAll('.header__menu-drawer__list__item__link'),
            sail: this.header.querySelector('.sail'),
        }

        this.init();
    }

    init() {
        this.animate();
    }

    openMenu() {
        document.body.classList.add('header--open');
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
            if (window.lenis != null) {
                window.lenis.stop();
            }
        }, 500);
    }

    closeMenu() {
        document.body.classList.remove('header--open');
        document.body.style.overflow = 'auto';
        if (window.lenis != null) {
            window.lenis.start();
        }
    }

    animate() {
        const headerDrawer = gsap.timeline({
            paused: true,
        });

        headerDrawer.fromTo(this.elements.menuDrawer, 
            {
                x: '-100%',
            },
            {
                duration: 1.5,
                display: 'block',
                ease: "power3.inOut",
                x: 0,
            }
        );
        
        headerDrawer.fromTo(this.elements.sail,
            {
                autoAlpha: 0,
            },
            {
                duration: 1.5,
                autoAlpha: 1,
            },
            0
        );

        headerDrawer.fromTo(this.elements.border,
            {
                width: '0%',
            },
            {
                duration: .9,
                width: '100%',
                stagger: 0.1,
            },
            .3
        );

        headerDrawer.fromTo(this.elements.logo,
            {
                autoAlpha: 0,
                y: '10px',
            },
            {
                delay: .4,
                duration: .5,
                autoAlpha: 1,
                y: 0,
            },
            .7
        );

        headerDrawer.fromTo(this.elements.menuItems,
            {
                y: '200%',
            },
            {
                duration: .8,
                y: 0,
                stagger: 0.08,
            },
            .9
        );

        function isTouchDevice() {
            return 'ontouchstart' in window || navigator.maxTouchPoints;
        }

        if(!isTouchDevice()) {
            this.elements.openMenu.addEventListener('mouseenter', () => {
                setTimeout(() => {
                    headerDrawer.play();
                    this.openMenu();
                }, 200);
            });
        }

        this.elements.openMenu.addEventListener('click', () => {
            headerDrawer.play();
            this.openMenu();
        });

        this.elements.closeMenu.addEventListener('click', () => {
            headerDrawer.reverse();
            this.closeMenu();
        });

        this.elements.sail.addEventListener('click', () => {
            headerDrawer.reverse();
            this.closeMenu();
        });

        this.elements.menuItems.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                headerDrawer.reverse();
                window.location = item.href;
                this.closeMenu();
            });
        });

        
        document.addEventListener('keyup', (e) => {
            if(e.keyCode === 27) {
                headerDrawer.reverse();
                this.closeMenu();
            }
        });

        // open menu if user press letter M
        document.addEventListener('keyup', (e) => {
            if(e.keyCode === 77) {
                headerDrawer.play();
                this.openMenu();
            }
        });

        // close menu if user press letter C
        document.addEventListener('keyup', (e) => {
            if(e.keyCode === 67) {
                headerDrawer.reverse();
                this.closeMenu();
            }
        });
    }
}

window.header = new Header();